angular.module('leanlaw').controller('Report3Ctrl', ['$scope', '$window', '$state', "alerts", "userService", "$rootScope", "apiCache", "$timeout", function ($scope, $window, $state, alerts, userService, $rootScope, apiCache, $timeout) {
  // Me is required before reports list can be generated
  // This is because the reports list has hardcoded names, and the Matter
  // term needs to be included as well
  userService.me().then(me => {
    $scope.me = me;
    $scope.showSidebar = false;
    const {
      settings
    } = me.company;
    const matterTerm = $scope.me.terms.Matter;
    const customFlagLabel = settings.labels && settings.labels.customFlag;
    $scope.reports = [{
      label: 'Sub reports',
      hide: true,
      reports: [{
        route: 'reports.contingency-detail',
        clientMatterPicker: true,
        showContingencyBilled: true
      }, {
        route: 'reports.client-summary',
        clientMatterPicker: true
        // showBilled: true,
        // showBilledDefault: 'any',
      }, {
        route: "reports.attorney-billable-detail",
        showBilled: true
      }, {
        route: "reports.attorney-revenue-invoices",
        revenueReport: true,
        hideExpense: true
      }, {
        route: "reports.attorney-revenue-unallocated",
        revenueReport: true
      }, {
        route: "reports.attorney-revenue-detail",
        revenueReport: true,
        hideExpense: true
      }, {
        route: "reports.practicearea-revenue-detail",
        revenueReport: true
      }, {
        route: "reports.originating-attorney-billed",
        revenueReport: true
      }, {
        route: "reports.originating-attorney-billed-detail",
        revenueReport: true
      }, {
        route: "reports.practicearea-revenue-invoices",
        revenueReport: true
      }, {
        route: "reports.originating-attorney-detail",
        revenueReport: true
      }, {
        route: "reports.originating-attorney-invoices",
        revenueReport: true
      }, {
        route: "reports.client-matter-revenue-invoices",
        revenueReport: true
      }]
    }, {
      label: 'Billable Reports',
      hide: !me.permissions.reports.billable,
      reports: [{
        name: `Billable by Client and ${matterTerm}`,
        route: "reports.client-matter-billables",
        info: `Overview how many billable and non-billable hours
                            were recorded for your clients. It also includes the dollar
                            value of your hours.`,
        showBilled: true,
        clientMatterPicker: true
      }, {
        name: `Billable by Practice Area`,
        route: "reports.practice-area-billables",
        info: `Overview how many billable and non-billable hours
                            were recorded for your practice areas. It also includes the dollar
                            value of your hours.`,
        showBilled: true,
        hide: !me.company.usesMatterTags,
        hideMatterTags: true
      }, {
        name: `Billable by Activity`,
        route: "reports.codes-billables",
        showBilled: true,
        hide: !me.features.activityReport || !(settings.codes && settings.codes.ledes)
      }, {
        name: `Billable by User`,
        route: "reports.attorney-billable",
        showBilled: true
      }, {
        name: `${customFlagLabel} Report`,
        route: "reports.client-matter-customflag",
        hide: !customFlagLabel
      }, {
        name: "Ready to Bill / WIP",
        route: "reports.ready-to-bill"
      }]
    }, {
      label: 'Contingency Reports',
      hide: !me.company.usesContingency,
      reports: [{
        name: `Contingency Statement`,
        route: "reports.contingency",
        clientMatterPicker: true,
        showContingencyBilled: true
      }, {
        name: `Expense Period Report`,
        route: "reports.contingency-expense",
        hideDate: true
      }]
    }, {
      label: 'Revenue Reports',
      reports: [{
        name: `Revenue by Client and ${matterTerm}`,
        hide: !me.permissions.reports.revenue,
        route: "reports.client-matter-revenue",
        info: `An overview of the financial situation for your clients
                            and matters. Client and Matter report with how much was billed
                            and collected. It can also include trust account balances and
                            receivables.`,
        clientMatterPicker: true,
        revenueReport: true
      }, {
        name: `Revenue by ${$scope.me.terms.Lead}`,
        hide: !me.permissions.reports.revenueAttorney,
        route: "reports.attorney-revenue",
        info: `Billed and Collected is split up by attorney based on the contribution of services on invoices`,
        revenueReport: true,
        hideExpense: true
      }, {
        name: `My Revenue`,
        hide: !me.permissions.reports.myrevenue,
        route: "reports.attorney-my-revenue",
        info: `Billed and Collected based on my contribution of services on invoices`,
        revenueReport: true,
        hideClientMatter: true,
        hideExpense: true
      }, {
        name: `Revenue by Practice Area`,
        route: "reports.practice-area-revenue",
        info: `Billed and collected per practice area`,
        hide: !me.permissions.reports.revenue || !me.company.usesMatterTags,
        hideMatterTags: true,
        revenueReport: true
      }, {
        name: `Collected by Originating ${$scope.me.terms.Lead}`,
        hide: !me.permissions.reports.revenue,
        route: "reports.originating-attorney",
        revenueReport: true
      }, {
        name: `Billed by Originating ${$scope.me.terms.Lead}`,
        hide: !me.permissions.reports.revenue,
        route: "reports.originating-attorney-billed",
        revenueReport: true
      }, {
        name: 'Receivables Invoice List',
        route: "reports.receivables-invoices-list",
        showBilled: false,
        hideMatterTags: true,
        hideArchived: true,
        hideDate: true
      }, {
        name: 'My Receivables Invoice List',
        route: "reports.my-receivables-invoices-list",
        showBilled: false,
        hideMatterTags: true,
        hideArchived: false,
        hideDate: true,
        hideClientMatter: true
      }, {
        name: 'Receivables',
        route: "reports.receivables",
        showBilled: false,
        clientMatterPicker: true,
        hideMatterTags: true,
        hideDate: true,
        hideArchived: true
      }]
    }, {
      label: `Productivity${me.adjustments ? ' and Write-down' : ''}`,
      hide: !me.permissions.reports.billable,
      margin: 30,
      reports: [{
        name: `Timekeeper Productivity`,
        hide: !me.permissions.reports.billable,
        route: "reports.timekeeper-productivity",
        info: `A report that summarizes every timekeeper's activity for every matter within the selected time period.`
      }, {
        name: `Productivity by Client`,
        hide: !me.permissions.reports.billable,
        route: "reports.client-matter-productivity"
      }]
    }, {
      label: 'Other Reports',
      reports: [{
        name: `Trust Report`,
        route: "reports.trust",
        hideDate: true,
        hide: !me.permissions.trust.view || !settings.trustEnabled
      }, {
        name: `Trust Statement`,
        route: "reports.trust-detail",
        hideMatterTags: true,
        hideClientMatter: true,
        hide: true,
        hideDate: true
      }, {
        name: `${$scope.me.terms.Custom1} Report`,
        route: "reports.custom",
        hideDate: true,
        hideClientMatter: true,
        hide: !me.features.customReport || !(settings.labels && settings.labels.custom1)
      }, {
        route: "reports.custom-detail",
        hide: true,
        hideDate: true,
        hideClientMatter: true
      }, {
        name: `Fixed Fee Profitability`,
        hide: !me.permissions.reports.billable,
        route: "reports.fixed-fee-profitability",
        info: `A report that provides a summary of fixed fee matters
                            by showing the fee for the matter, the amount that would have
                            been billed against the matter if it was billed hourly instead
                            of fixed fee, and the difference between the two amounts.`
      }, {
        name: `Period Reports`,
        hide: !me.permissions.reports.billable,
        route: "reports.period-reports",
        hideDate: true
      }, {
        name: `${matterTerm} Rates`,
        route: "reports.matter-rates",
        hideDate: true
      }, {
        name: `${matterTerm} Activity`,
        route: "reports.matter-activity",
        hideDate: true
      }, {
        name: `Client Contact Information`,
        route: "reports.client-contact",
        hideDate: true,
        hideMatterTags: true
      }]
    }, {
      label: 'My Reports',
      reports: [{
        name: 'My Receivables',
        route: "reports.my-receivables",
        showBilled: false,
        clientMatterPicker: true,
        hideMatterTags: true,
        hideDate: true,
        hideArchived: false,
        hideClientMatter: true
      }]
    }];
    refreshCurrentReport();
  });
  $scope.returnLabel = $state.params.returnLabel;
  $scope.clientDateRange = $state.params.dateRange;
  $scope.dateRangeId = $state.params.dateRangeId;
  $scope.openReport = function (report) {
    $state.go(report.route);
  };
  $scope.closeReport = function () {
    const {
      returnRoute,
      returnParams
    } = $state.params;
    if (returnRoute) {
      $state.go(returnRoute, returnParams);
    } else {
      $state.go("reports.dashboard");
    }
  };
  $scope.isSidebarOpen = function () {
    return $state.current.name !== "reports.dashboard" && $state.current.name !== "reports.upgrade";
  };

  // Eight sidebar bindings read this every digest, so the flatten happens on state
  // change instead of per call.
  let currentReport;
  const refreshCurrentReport = function refreshCurrentReport() {
    const reports = [].concat(...($scope.reports || []).map(r => r.reports));
    currentReport = reports.find(r => r.route === $state.current.name);
  };
  $scope.currentReport = function () {
    return currentReport;
  };
  refreshCurrentReport();
  const stopReportWatch = $rootScope.$on('$stateChangeSuccess', refreshCurrentReport);

  // Make sure window is always below the header, even after media queries are applied
  const resizeViewport = function resizeViewport() {
    const h = $(".ts.header").height();
    $(".reports, .edit-sidebar").css({
      top: `${h}px`
    });
  };
  $scope.$on('closeSidebar', (event, data) => {
    $scope.showSidebar = data;
  });
  resizeViewport();
  // .reports isn't in the DOM yet while the controller body runs, so measure again
  // once it is. The interval used to be what eventually corrected this.
  const firstMeasure = $timeout(resizeViewport);

  // The header's own height is the only input here, so observing it replaces a
  // 100ms timer that forced a layout read and write ten times a second for as long
  // as Reports was open.
  const header = $(".ts.header")[0];
  const headerObserver = header && $window.ResizeObserver ? new $window.ResizeObserver(resizeViewport) : null;
  if (headerObserver) headerObserver.observe(header);

  // Watch for page resizes and adjust visible content accordingly
  angular.element($window).bind("resize", resizeViewport);
  $scope.$on("$destroy", () => {
    angular.element($window).off("resize", resizeViewport);
    if (headerObserver) headerObserver.disconnect();
    $timeout.cancel(firstMeasure);
    stopReportWatch();
  });
  // Default viewport top height:
  $(".reports, .edit-sidebar").css({
    top: "74px"
  });
  const deactivate = $rootScope.$on('$stateChangeStart', (_, toState) => {
    if (toState.name.indexOf('reports.') !== 0 || toState.name === 'reports.dashboard') {
      // clear all cache when navigating away from reports or to the dashboard
      apiCache.clear();
      deactivate();
    }
  });
  if ($state.current.name === 'reports') {
    $state.go('reports.dashboard');
  }
}]);